module.exports = __webpack_public_path__ + "img/full6-min.5b4e4344.png";